/* eslint-disable */
import colors from '../../../../../public/colors'

export default theme => {
    const mode = theme?.palette?.mode || 'light'
    
    return {
        contentWrapper: {
                    backgroundColor: colors[mode].secondaryBackground,
                    display: 'flex',
                    flex: 1,            
                    flexDirection: 'column',
                    justifyContent: 'center',
            },
    gridContainerCenter: {
                backgroundColor: colors[mode].secondaryBackground,
                boxSizing: 'border-box',
                display: 'flex',
                justifyContent: 'center',
                padding: '3% 0% 5% 0%',
                width: '100%',
                [theme.breakpoints.down('md')]: {
                    padding: '5% 5%'
                },
                [theme.breakpoints.down('sm')]: {
                    gridTemplateColumns: '1fr',
                    padding: '4% 4%'
                },
                [theme.breakpoints.down('xs')]: {
                    gridTemplateColumns: '1fr',
                    padding: '3% 3%'
                }
    },
    languageButton: {
        boxShadow: 'none',
        color: 'rgb(0, 81, 165)',
        float: 'right',
        fontSize: '10px',
        width: '35%',
        marginLeft: '65%'
    },
    linearProgress: {
        left: 0,
        position: 'fixed',
        top: '72px',
        width: '100%',
        zIndex: -1,
        [theme.breakpoints.down('sm')]: {
            top: '56px'
        }
    },
    loader: {
        height: '100%',
        left: '0',
        position: 'absolute',
        top: '0',
        width: '100%',
        'z-index': '10'
    },
    registrationRoot: {
        padding: theme.spacing(6, 4, 4, 4)
    },
    stickyHeader: {
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        width: '100%',
        zIndex: theme.zIndex.appBar || 1100,        
        '@supports (-webkit-touch-callout: none)': {
            position: 'fixed',
            transform: 'translate3d(0, 0, 0)',
            backfaceVisibility: 'hidden',
            willChange: 'transform',
            WebkitTransform: 'translate3d(0, 0, 0)',
            WebkitBackfaceVisibility: 'hidden'
        },
        
        [theme.breakpoints.down('sm')]: {
            position: 'fixed',
            zIndex: (theme.zIndex.appBar || 1100) + 1,
            transform: 'translateZ(0)',
            
            '@supports (-webkit-touch-callout: none)': {
                position: 'fixed',
                top: 'env(safe-area-inset-top, 0)',
                WebkitTransform: 'translateZ(0)',
                transform: 'translateZ(0)'
            }
        }
    },
    pageWrapper: {
        display: 'flex',
        flexDirection: 'column',
        maxWidth: '100vw',
        minHeight: '100vh',
        overflow: 'hidden',  
    }
}
}